<div class="home-container global-settings">
  @if (unauthorizedHouseId) {
    <div class="unauthorized-message">
      <p>Der Haushalt <strong>{{ unauthorizedHouseId }}</strong> kann nicht angezeigt werden. Entweder existiert er nicht oder Sie haben keine Berechtigung, ihn einzusehen.</p>
    </div>
  } @else {
    <div class="component-spacing">
      <app-consumption-chart (timeRangeChange)="onTimeRangeChanged($event)" [data]="consumptionTableData"></app-consumption-chart>
    </div>

    <div class="component-spacing">
      <app-consumption-table [data]="consumptionTableData"></app-consumption-table>
    </div>
  }
</div>
